<template>
	<div ref="content">
		<loading-animation v-if="showLoading" class="row border border-top-0"></loading-animation>
	</div>
</template>

<script>
import ApiService from "../../../ceres/services/ApiService";

export default {
    name: "category-content",

	props: {
		categoryId: {
			type: Number,
			required: true
		},
		contentType: {
            type: Array,
            default: () => []
		},
		removeSeoRelevance: {
			type: Boolean,
			default: true
		},
		showInitialTitle: {
			type: Boolean,
			default: false
		},
		showLoading: {
			type: Boolean,
			default: true
		},
		replacePattern: {
            type: Array,
            default: () => []
		},
		removeSelector: {
            type: Array,
            default: () => []
		}
	},

	mounted() {
		if (this.contentType.length > 0) {
			this.getCategoryContent(this.contentType[0]);
		}
	},

	methods: {
		getCategoryContent(contentType) {
			let payload = {
				removeSEORelevance: this.removeSeoRelevance,
				showInitialTitle: this.showInitialTitle
			};

			if (
				this.replacePattern.length > 0 &&
				this.replacePattern[0].pattern !== ""
			) {
				payload = {
					...payload,
					replacePattern: this.replacePattern
				};
			}

			if (
				this.removeSelector.length > 0 &&
				this.removeSelector[0] !== ""
			) {
				payload = {
					...payload,
					removeSelector: this.removeSelector
				};
			}

			ApiService.get("/rest/category/" + this.categoryId + "/" + contentType, payload, { supressNotifications: true })
                .done(response =>
                {
					if (Object.keys(response).includes("data")) {
						this.executeAnotherType(contentType);
					} else {
						this.compileResponse(response);
					}
                })
				.fail(() =>
				{
					this.compileResponse("");
				})
		},
		executeAnotherType(lastContentType) {
			let foundLastType = false;

			this.contentType.some(contentType => {
				if (foundLastType) {
					this.getCategoryContent(contentType);
					return true;
				} else {
					foundLastType = (contentType === lastContentType);
				}
			});
		},
		compileResponse(response) {
			const compiled = Vue.compile('<div>' + response + '</div>');
			const vueOptions = {
				render: compiled.render,
				staticRenderFns: compiled.staticRenderFns
			};

			if (!!window.ceresStore) {
				vueOptions.store = window.ceresStore;
			}

			const component = new Vue(vueOptions);

			component.$mount(this.$refs.content);
		}
	}
};
</script>